import { SAVED_DASHBOARDS_STATE_KEY } from '@utils/constants';
import { useQuery } from 'react-query';

function useInitSave(pageKey) {
  useQuery({
    queryKey: [SAVED_DASHBOARDS_STATE_KEY, pageKey],
    staleTime: Infinity,
    initialData: {
      meta: {},
      config: {},
      initialSavedData: {},
    },
  });
}

export default useInitSave;
